import axios from '../../http/axios/index.js'

export default {
  getAllSubproyectos ({ commit }, request) {
    console.log("request suprojects: " + JSON.stringify(request))
    return new Promise((resolve, reject) => {
      axios
        .post('/getAllSubproject', request)
        .then(response => {
          console.log('Subproyectos ', response.data)

          if (response.data.v_code === 0) {
            console.log('Subproyectos length', response.data.listData.length)

            const lista = response.data.listData ? response.data.listData : []
            commit('SET_SUBPROYECTOS', lista)
            resolve(response)
          } else {
            reject(response.v_errm)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  insertOrReplaceSubproyecto ({ commit }, subproyecto) {
    return new Promise((resolve, reject) => {
      axios
        .post('/insertOrReplaceSubproject', subproyecto)
        .then(response => {
          if (response.data.v_code === 0) {
            commit('ID_SUBPROYECTO_MODIFICADO', response.data.id_subproject)
            resolve(response)
          } else {

            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  deactivateSubproyecto ({ commit }, subproyecto) {
    subproyecto.is_active = "N"
    console.log("subproyecto: " + JSON.stringify(subproyecto))
    return new Promise((resolve, reject) => {
      axios
        .post('/insertOrReplaceSubproject', subproyecto)
        .then(response => {
          if (response.data.v_code === 0) {
            commit('ID_SUBPROYECTO_MODIFICADO', response.data.id_subproject)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    }
    )
  },
}
